export default __webpack_public_path__ + "static/media/aurore.605aeebe.png";